import React from 'react'
import PropTypes from 'prop-types'

FacilityCardEmptyImage.propTypes = {
    url: PropTypes.string,
    enableWatermark: PropTypes.bool,
    enableAttribution: PropTypes.bool,
    pixelHeight: PropTypes.number

}
export function FacilityCardEmptyImage(props)  {

    return <div className={'facility-card-empty-avatar'} style={{
        backgroundImage:'url("'+props.url+'")'
    }}><div className={'facility-card-empty-avatar-text-wrapper'}>
        {props.enableWatermark &&
            <div className={'facility-card-watermark'}>
                &nbsp;
                {props.enableAttribution &&
                    <div className={'facility-card-empty-avatar-caption'}>AI Image Generated By Stable Diffusion</div>
                }
            </div>
        }
        </div>
    </div>

}
